module.exports = __webpack_public_path__ + "5c07b38e32c7476cb9158a563d62656d.png";